export const roleToCategory = (role) => {
  switch (role) {
    case "Planner":
      return [
        "Account Creation",
        "Portfolio and Profile",
        "Packages",
        "Bookings and Orders",
        "Payments",
        "Visibility",
        "Trust and Safety",
        "Ratings and Reviews",
      ];
    case "Event Host":
      return [
        "Getting Started",
        "Posting a Requirement",
        "Booking and Payments",
        "Packages",
        "Cancellations and Refunds",
        "Event Day and Reviews",
        "Policies and Safety",
      ];
    case "Performer":
      return [
        "Account Creation",
        "Portfolio and Profile",
        "Packages",
        "Bookings",
        "Payments",
        "Ratings and Reviews",
        "Visibility",
        "Trust and Safety",
      ];
    case "Crew":
      return [
        "Account Creation",
        "Portfolio and Profile",
        "Bookings",
        "Payments",
        "Ratings and Reviews",
        "Visibility",
        "Reliability and Strikes",
      ];
    default:
      return "";
  }
};
